// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f5692152","732":"c7b35a28","977":"d01c2525"}[chunkId] + ".chunk.js";
};